"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpanderColumn = exports.EXPANDER_CELL_ID = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const index_js_1 = require("../../utils/index.js");
const index_js_2 = require("../../Buttons/index.js");
const index_js_3 = require("../cells/index.js");
exports.EXPANDER_CELL_ID = 'iui-table-expander';
/**
 * Expander column that adds sub-content expander column to the Table.
 * It is recommended to use it as the first column or after selection column.
 * @example
 * const subComponent = useCallback(
 *   (row: Row) => (
 *     <div style={{ padding: 16 }}>
 *       <Leading>Extra information</Leading>
 *       <pre>
 *         <code>{JSON.stringify({ values: row.values }, null, 2)}</code>
 *       </pre>
 *     </div>
 *   ),
 *   [],
 * );
 * const isExpanderDisabled = useCallback((rowData) => {
 *   return rowData.name === 'Name2';
 * }, []);
 * const columns = useMemo(() => [
 *   ExpanderColumn({ subComponent, isDisabled: isExpanderDisabled }),
 *   // Rest of your columns
 * ], [isExpanderDisabled, subComponent]);
 */
const ExpanderColumn = (props = {}) => {
    const { subComponent, isDisabled } = props;
    return {
        id: exports.EXPANDER_CELL_ID,
        disableResizing: true,
        disableGroupBy: true,
        disableReordering: true,
        minWidth: 48,
        width: 48,
        maxWidth: 48,
        columnClassName: 'iui-slot',
        cellClassName: 'iui-slot',
        Cell: (props) => {
            const { row } = props;
            if (!(subComponent === null || subComponent === void 0 ? void 0 : subComponent(row))) {
                return null;
            }
            else {
                return (React.createElement(index_js_2.IconButton, { className: 'iui-table-row-expander', styleType: 'borderless', size: 'small', onClick: (e) => {
                        e.stopPropagation();
                        row.toggleRowExpanded();
                    }, disabled: isDisabled === null || isDisabled === void 0 ? void 0 : isDisabled(props.row.original) }, React.createElement(index_js_1.SvgChevronRight, null)));
            }
        },
        cellRenderer: (props) => (React.createElement(index_js_3.DefaultCell, { ...props, isDisabled: (rowData) => !!(isDisabled === null || isDisabled === void 0 ? void 0 : isDisabled(rowData)) })),
    };
};
exports.ExpanderColumn = ExpanderColumn;
